var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1998 12C23.1998 18.1857 18.1854 23.2 11.9998 23.2C5.81421 23.2 0.799805 18.1857 0.799805 12C0.799805 5.81446 5.81421 0.800049 11.9998 0.800049C18.1854 0.800049 23.1998 5.81446 23.1998 12ZM14.7998 7.80005C14.7998 9.34645 13.5462 10.6 11.9998 10.6C10.4534 10.6 9.1998 9.34645 9.1998 7.80005C9.1998 6.25365 10.4534 5.00005 11.9998 5.00005C13.5462 5.00005 14.7998 6.25365 14.7998 7.80005ZM11.9997 13.4C9.17515 13.4 6.74132 15.073 5.63504 17.482C7.17545 19.2688 9.45551 20.4 11.9998 20.4C14.544 20.4 16.8241 19.269 18.3645 17.4822C17.2582 15.073 14.8243 13.4 11.9997 13.4Z",
    fill: "#FF010B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRed);
export default __webpack_public_path__ + "static/media/user_red.783bb7b6c635cdd3fdd09bd406fa7436.svg";
export { ForwardRef as ReactComponent };